module.exports = __webpack_public_path__ + "img/微信图片_20240923162536.bf01f4fb.jpg";